/* global process */
// Guest mode helpers. Kept dependency-free on purpose: auth.service imports the store, and store
// modules need this — importing auth.service from a store module would be an import cycle.

/** Event name the globally-mounted UpgradeModal (AppLayout) listens for. */
export const UPGRADE_REQUIRED_EVENT = 'busy:upgrade-required'

/** A signed-in free user hit a paid boundary (AI limit, crown button) — open the Pro upgrade overlay. */
export function suggestUpgrade() {
  window.dispatchEvent(new CustomEvent(UPGRADE_REQUIRED_EVENT))
}

/**
 * The save boundary: a guest tried to persist something, which needs a user id — send them to
 * the real Busy sign-in (IDS) as a plain full-page redirect, and come back to exactly where
 * they were. A popup/overlay is NOT used: opening accounts.appsbooth.com in a popup is fragile
 * (blockers, third-party-cookie rules), so we navigate for real.
 *
 * Their collected research (the workboard) survives the round-trip via sessionStorage — same tab,
 * same browsing session, so it comes back with them and dies with the session (#84).
 */
export function loginForSave() {
  const returnUrl = window.location.href
  sessionStorage.setItem('redirectedUri', returnUrl)
  window.location.href =
    `${process.env.VUE_APP_BFF_URL}/bff/login?returnUrl=` + encodeURIComponent(returnUrl)
}

/**
 * Wraps the given store actions so a guest triggering them opens the sign-in overlay instead.
 * Returns a promise that never settles: the save did not happen, and settling would let the
 * caller's success path run against it. After signing in the user retries the action, which
 * then runs normally.
 */
export function gateActionsBehindLogin(actions, names) {
  for (const name of names) {
    const original = actions[name];
    if (!original) continue;
    actions[name] = function (ctx, payload) {
      if (!ctx.rootGetters["user/isAuthenticated"]) {
        loginForSave();
        return new Promise(() => {});
      }
      return original.call(this, ctx, payload);
    };
  }
}
